import { message } from 'antd'
import { adminApi } from '~/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { courseParticipantsQueryKey } from './query'
import { clipboard, showErrors } from '~/utils/helpers'

export const useSendAllLoginDetailMutation = (courseId) =>
  useMutation(
    async () => {
      const { data } = await adminApi.sendAllLoginDetails(courseId)
      return data.data
    },
    {
      onSuccess: () => {
        message.success("Student's login details has been sent successfully")
      },
      onError: showErrors
    }
  )

export const useSendStudentLoginDetailMutation = (courseId) =>
  useMutation(
    async ({ studentId, testing }) => {
      const { data } = await adminApi.sendStudentLoginDetails(courseId, studentId, testing)
      return data.data
    },
    {
      onSuccess: () => {
        message.success("Student's login details has been sent successfully")
      },
      onError: showErrors
    }
  )

export const useImportStudentMutation = (courseId) => {
  const queryClient = useQueryClient()

  return useMutation(
    (payload) => adminApi.importStudent(courseId, payload.file),
    {
      onSuccess: () => {
        const key = courseParticipantsQueryKey(courseId)
        queryClient.invalidateQueries({ queryKey: key })
        message.success('Import successfully')
      },
      onError: showErrors
    }
  )
}

export const useStudentEnabledMutation = (courseId) => {
  const queryClient = useQueryClient()
  return useMutation(
    async (studentId) => {
      const { data } = await adminApi.editStudentEnabled(courseId, studentId)
      return data.data
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['courses', courseId] })
        message.success('Success')
      },
      onError: (error) => {
        message.error(error.response?.data?.message)
      }
    }
  )
}

export const useStudentPreAccessMutation = (courseId) => {
  const queryClient = useQueryClient()
  return useMutation(
    async (studentId) => {
      const { data } = await adminApi.editStudentPreAccess(courseId, studentId)
      return data.data
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['courses', courseId] })
        message.success('Success')
      },
      onError: (error) => {
        message.error(error.response?.data?.message)
      }
    }
  )
}

export const useNativeAppstreamLinkMutation = (courseId) =>
  useMutation(
    async (studentId) => {
      const { data } = await adminApi.getNativeAppstreamLink(courseId, studentId)
      return data.data
    },
    {
      onSuccess: (data) => {
        clipboard(data)
        message.success('Copied')
      },
      onError: (error) => {
        message.error(error.response?.data?.message)
      }
    }
  )
